const theme = {
  primary: '#a91f34',
  secondary: '#8e1528',
  text: {
    primary: '#333',
  },
};

export default theme;
